import React from "react";
import CustomerSearchInput from "../common/CustomerSearch";

export default function FiltersBar({ customers = [], header, setHeader }) {
  return (
    <div className="container-fluid mt-2" id="filters">
      {/* Serial */}

      <label>Serial Number</label>
      <input
        type="number"
        placeholder="Enter Serial Number"
        value={header.serial || "---"}
        readOnly={true}
      />

      {/* Date */}

      <label>Date</label>
      <input
        type="date"
        value={header.date}
        onChange={(e) => setHeader({ ...header, date: e.target.value })}
      />

      {/* Customer */}

      {/* <label>Party Name</label>
      <select
        className="kw-customer-select"
        onChange={(e) => {
          const customer = customers.find((c) => c._id === e.target.value);
          setHeader({ ...header, selectedCustomer: customer });
        }}
      >
        <option value="">-- Customer Select Karo --</option>

        {customers?.map((customer) => (
          <option key={customer._id} value={customer?._id}>
            {customer.name} | {customer.phone}
          </option>
        ))}
      </select> */}
      <label>Party Name</label>
      <CustomerSearchInput
        customers={customers}
        value={header.selectedCustomer}
        onChange={(customer) =>
          setHeader({ ...header, selectedCustomer: customer })
        }
        inputClass="kw-customer-select" // 👈 keeps your same style
      />

      {/* Satisfaction */}

      <label>Satisfaction</label>
      <select
        value={header.satisfaction}
        onChange={(e) => setHeader({ ...header, satisfaction: e.target.value })}
      >
        <option value="satisfied">😊 Satisfied</option>
        <option value="neutral">😐 Neutral</option>
        <option value="unsatisfied">😞 Unsatisfied</option>
      </select>

      {/* Time */}

      <label>Time</label>
      <input
        type="time"
        value={header.time}
        onChange={(e) => setHeader({ ...header, time: e.target.value })}
      />
    </div>
  );
}
